import { inject, Injectable } from '@angular/core';
import { StorageService } from '@core/storage/services/storage.service';
import { OrganizationManagerStoreData } from '@core/organization-managers/models/organization-managers-store-data.interface';

@Injectable({
  providedIn: 'root',
})
export class OrganizationManagersStorageFacade {
  private readonly storageService = inject(StorageService);

  areOrganizationManagersCollapsed(): boolean {
    const organizationManagersData = this.organizationManagersData;

    if (!organizationManagersData) {
      return true;
    }

    return organizationManagersData.isCollapsed;
  }

  setOrganizationManagersCollapsedState(isCollapsed: boolean): void {
    const organizationManagersData = this.organizationManagersData ?? {};

    this.storageService.setOrganizationManagersData({
      ...organizationManagersData,
      isCollapsed,
    });
  }

  private get organizationManagersData(): OrganizationManagerStoreData | undefined {
    return this.storageService.getOrganizationManagersData();
  }
}
